import React from 'react';

import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'

import moment from 'moment';

import './Footer.css';

import FooterNewsletter from '../FooterNewsletter/FooterNewsletter'

import { getSession } from '../../utils'
import config from '../../config';
import { default as withRouter } from "../WithRouter/withRouter";

import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';

const today = moment();
const currentYear = today.year();

class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      session: null,
    };
  }

  async componentDidMount() {
    this.setState({
      session: getSession()
    })
  }

  render() {
    const calculatorPages = [
      '/im-a-homeowner',
      '/im-a-renter',
      '/im-a-business-owner',
      '/im-something-else',
      '/im-a-non-profit',
      '/im-indigenous'
    ];
    const isCalculatorPage = calculatorPages.includes(this.props.router.location.pathname);

    return (
      <div>
        {!this.state.session && !isCalculatorPage &&
          <FooterNewsletter />
        }
        <Navbar bg="dark" variant="dark">
          <Nav className='m-auto'>
            <small className="text-muted m-auto pr-2">Reciprocity Trusts is a not-for-profit initiative of Reciprocity Research Inc.,
              a social enterprise found at&nbsp;<a href={`${config.domains.marketing}/`}>reciprocitytrusts.ca</a>. &copy;&nbsp;{currentYear}
            </small>
            <Nav.Link href="https://www.facebook.com/reciprocitytrusts" target="_blank">
              <FacebookIcon className="footer-social-media"></FacebookIcon>
            </Nav.Link>
            <Nav.Link href="https://x.com/reciprocity_ca" target="_blank">
              <XIcon className="footer-social-media"></XIcon>
            </Nav.Link>
            <Nav.Link href="https://www.instagram.com/reciprocitytrusts/" target="_blank">
              <InstagramIcon className="footer-social-media"></InstagramIcon>
            </Nav.Link>
            <Nav.Link href="https://www.youtube.com/@ReciprocityTrusts" target="_blank">
              <YouTubeIcon className="footer-social-media"></YouTubeIcon>
            </Nav.Link>
            <Nav.Link href="mailto:hello@reciprocityconnects.ca" target="_blank">
              <MailIcon className="footer-social-media"></MailIcon>
            </Nav.Link>
            <Nav.Link href="tel:778-606-2511" target="_blank">
              <PhoneIcon className="footer-social-media"></PhoneIcon>
            </Nav.Link>
          </Nav>
        </Navbar>
      </div>
    );
  }
}

export default withRouter(Footer);
